import { EligibilityAdapter } from './eligibility.adapter';

export class EligibilityService extends EligibilityAdapter {}
